import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionFunnelChart = ({ data }) => {
  const maxValue = Math.max(...data?.map(item => item?.value));

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Bid Conversion Funnel</h3>
        <Icon name="TrendingUp" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-3 md:space-y-4">
        {data?.map((stage, index) => {
          const widthPercentage = (stage?.value / maxValue) * 100;
          const conversionRate = index > 0 ? ((stage?.value / data?.[index - 1]?.value) * 100)?.toFixed(1) : 100;
          
          return (
            <div key={stage?.id}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon name={stage?.icon} size={18} className="text-muted-foreground" />
                  <span className="text-sm md:text-base font-medium text-foreground">{stage?.label}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold text-foreground">{stage?.value}</span>
                  {index > 0 && (
                    <span className="text-xs text-muted-foreground">({conversionRate}%)</span>
                  )}
                </div>
              </div>
              <div className="relative h-10 md:h-12 bg-muted rounded-lg overflow-hidden">
                <div 
                  className="absolute left-0 top-0 h-full bg-gradient-to-r from-accent to-accent/70 flex items-center justify-center transition-all duration-500"
                  style={{ width: `${widthPercentage}%` }}
                >
                  {widthPercentage > 20 && (
                    <span className="text-xs md:text-sm font-medium text-white">{stage?.value} {stage?.label}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-accent/5 rounded-lg border border-accent/20">
        <div className="flex items-center justify-between">
          <span className="text-sm text-foreground">Overall Conversion Rate</span>
          <span className="text-lg font-semibold text-accent">
            {((data?.[data?.length - 1]?.value / data?.[0]?.value) * 100)?.toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConversionFunnelChart;